import React from "react";
import { Box, Typography } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

const MOOD_OPTIONS = [
  {
    value: 1,
    label: "Awful",
    icon: <SentimentVeryDissatisfiedIcon sx={{ fontSize: 36 }} />,
    color: "#cb5538",
  },
  {
    value: 2,
    label: "Not great",
    icon: <SentimentDissatisfiedIcon sx={{ fontSize: 36 }} />,
    color: "#c26229",
  },
  {
    value: 3,
    label: "Okay",
    icon: <SentimentNeutralIcon sx={{ fontSize: 36 }} />,
    color: "#ffa600",
  },
  {
    value: 4,
    label: "Good",
    icon: <SentimentSatisfiedIcon sx={{ fontSize: 36 }} />,
    color: "#83a32e",
  },
  {
    value: 5,
    label: "Amazing",
    icon: <SentimentSatisfiedAltIcon sx={{ fontSize: 36 }} />,
    color: "#197b68",
  },
];

/**
 * Asks the user how their mood is today, with 5 card options.
 */
const MoodStep = ({ selected, onSelect }) => {
  return (
    <Box className="task-guide-step task-guide-step--mood">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          So, what's your mood like right now?
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-step__mood-cards">
        {MOOD_OPTIONS.map((option) => (
          <Box
            key={option.value}
            className={`task-guide-step__mood-card ${selected === option.value ? "task-guide-step__mood-card--selected" : ""}`}
            onClick={() => onSelect(option.value)}
            sx={{
              borderColor:
                selected === option.value ? option.color : "transparent",
              "&:hover": { borderColor: option.color },
            }}
          >
            <Box sx={{ color: option.color }}>{option.icon}</Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, mt: 0.5, fontSize: "0.8rem" }}
            >
              {option.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MoodStep;
